import { render } from "./StockTakes.vue?vue&type=template&id=327f04ce&scoped=true"
import script from "./StockTakes.vue?vue&type=script&lang=js"
export * from "./StockTakes.vue?vue&type=script&lang=js"

import "./StockTakes.vue?vue&type=style&index=0&id=327f04ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327f04ce"]])

export default __exports__